import { render, staticRenderFns } from "./pickPackShipStep2.vue?vue&type=template&id=5b8a7767&scoped=true"
import script from "./pickPackShipStep2.vue?vue&type=script&lang=js"
export * from "./pickPackShipStep2.vue?vue&type=script&lang=js"
import style0 from "./pickPackShipStep2.vue?vue&type=style&index=0&id=5b8a7767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a7767",
  null
  
)

export default component.exports